var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-content-container',[_c('Editor',{attrs:{"value":_vm.value,"viewOnly":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }